import { render } from "./FileUploader.vue?vue&type=template&id=1eadb274&scoped=true"
import script from "./FileUploader.vue?vue&type=script&lang=js"
export * from "./FileUploader.vue?vue&type=script&lang=js"

import "./FileUploader.vue?vue&type=style&index=0&id=1eadb274&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eadb274"]])

export default __exports__